import React from 'react';
import IconedPanel from 'components/IconedPanel';

import { useSelectedCar } from 'features/myFleet';
import { getCarType } from 'entities/cars';
import { useIntl } from 'react-intl';

export const CarInformation = () => {
  const { currentVehicle, trailerAxles, grossTrainWeight } = useSelectedCar() || {};
  const { formatMessage } = useIntl();

  return (
    <>
      {
        currentVehicle && currentVehicle.weights && (
          <IconedPanel
            icon="auto"
            title={`${formatMessage({ id: 'vehicleType' })}: ${getCarType(currentVehicle.weights.vehicleWeightUnladen)}`}
            gutterBottom={1}
          />
        )
      }
      {
        currentVehicle && (
          <IconedPanel
            icon="axles"
            title={`${formatMessage({ id: 'axesNumber' })}: ${currentVehicle.axleCount}`}
            gutterBottom={1}
          />
        )
      }
      {
        trailerAxles && (
          <IconedPanel
            icon="trailer"
            title={`${formatMessage({ id: 'trailerAxleCount' })}: ${trailerAxles.value}`}
            gutterBottom={1}
          />
        )
      }
      {
        grossTrainWeight && (
          <IconedPanel
            icon="scale"
            title={`${formatMessage({ id: 'grossWeight' })} (${formatMessage({ id: 'kg' })}): ${grossTrainWeight.value}`}
            gutterBottom={0}
          />
        )
      }
    </>
  );
};
